import { useContext } from 'react';

import SalesforceChatContext from './SalesforceChatContext';

import type { SalesforceChatContextType } from './SalesforceChatContext';

const useSalesforceChat = (): SalesforceChatContextType => {
    const context = useContext(SalesforceChatContext);
    if (!context) {
        throw new Error('useSalesforceChat must be used within SalesforceChatProvider');
    }
    return context;
};

export default useSalesforceChat;
